export default class Utilities {
  constructor() {
    const printButton = document.querySelector('.print-button');
    const hasExternalLink = Array.from(document.querySelectorAll('a[href]')).some((link) => {
      try {
        const url = new URL(link.getAttribute('href'), window.location.href);
        return url.hostname !== window.location.hostname;
      } catch (err) {
        return false;
      }
    });

    if (printButton) {
      this.initPrintButton(printButton);
    }

    if (hasExternalLink) {
      this.externalLinksAlert();
    }

    this.initGranicusLiveStatus();

    this.highlightCountyLinks();
  }

  initPrintButton(printButton) {
    printButton.addEventListener('click', (e) => {
      e.preventDefault();
      window.print();
    });
  }

  initGranicusLiveStatus() {
    this.checkGranicusLive();
    setInterval(() => this.checkGranicusLive(), 300000);
  }

  async checkGranicusLive() {
    const liveVideoEl = document.querySelector('.live-video');
    if (!liveVideoEl) return;

    // TEST OVERRIDE: add ?test_live=1 to the URL to force the live state
    if (new URLSearchParams(window.location.search).has('test_live')) {
      liveVideoEl.href = 'https://alachua.granicus.com/MediaPlayer.php?view_id=8&event_id=999';
      liveVideoEl.closest('.h-100')?.classList.remove('d-none');
      return;
    }

    // TODO: old site's endpoint (sp19.alachuacounty.us ASMX) has no public DNS
    // and is dead. Need a working Granicus endpoint before enabling this.
    return;

    /* eslint-disable no-unreachable */
    try {
      const res = await fetch('REPLACE_WITH_WORKING_GRANICUS_ENDPOINT', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: '{ evtParam:events, id:none}',
      });
      const outer = await res.json();
      const eventsJson = outer.GetEventsResult ?? outer.d;
      const events = JSON.parse(eventsJson);

      const live = events.find((e) => e && e.Status === 'Running');

      if (live) {
        liveVideoEl.href = `https://alachua.granicus.com/MediaPlayer.php?view_id=8&event_id=${live.ID}`;
        liveVideoEl.closest('.h-100')?.classList.remove('d-none');
      } else {
        liveVideoEl.closest('.h-100')?.classList.add('d-none');
      }
    } catch (err) {
      console.error('Granicus live status check failed', err);
    }
    /* eslint-enable no-unreachable */
  }

  externalLinksAlert() {
    let pendingUrl = null;
    let pendingTarget = null;

    const modal = document.createElement('div');
    modal.className = 'modal d-none';
    modal.style.background = 'rgba(0,0,0,0.5)';
    modal.style.zIndex = '1050';

    modal.innerHTML = `
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-4 border-0 border-bottom border-5 border-ac-primary rounded-0 p-5 text-center">
          <h2 class="h3">You are leaving the Alachua County Website</h2>
          <p class="mt-4">Thank you for visiting the Alachua County website. By clicking "Ok" you will be redirected to a non-County maintained website. Alachua County may not be responsible for the content at the site you are about to be linked to.</p>
          <div class="d-flex gap-4 justify-content-center mt-3">
            <button type="button" class="btn-ok btn btn-ac-blue px-4">OK</button>
            <button type="button" class="btn-cancel btn btn-ac-lightgray px-4">Cancel</button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    const closeModal = () => {
      modal.classList.remove('d-block');
      modal.classList.add('d-none');
      pendingUrl = null;
      pendingTarget = null;
    };

    const openModal = () => {
      modal.classList.remove('d-none');
      modal.classList.add('d-block');
    };

    modal.querySelector('.btn-ok').addEventListener('click', () => {
      if (pendingUrl) window.open(pendingUrl, pendingTarget || '_self');
      closeModal();
    });

    modal.querySelector('.btn-cancel').addEventListener('click', closeModal);

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');

      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
        return;
      }

      if (/\.(pdf|docx?|xlsx?|pptx?|zip|rar|csv|txt|jpg|jpeg|png|gif|svg|mp3|mp4|avi)$/i.test(href)) {
        return;
      }

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch (err) {
        return;
      }

      if (url.hostname === window.location.hostname) return;

      e.preventDefault();
      pendingUrl = url.href;
      pendingTarget = link.target;
      openModal();
    }, false);
  }

  // Highlight links that point to old site 
  highlightCountyLinks() {
    document.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);

        const isCountyLink = url.hostname === 'alachuacounty.us';
        const isOriginAspx =
          url.hostname === 'origin-alachua.solodev.net' &&
          url.pathname.endsWith('.aspx');

        if (isCountyLink || isOriginAspx) {
          link.style.backgroundColor = 'yellow';
        }
      } catch (err) {
        // Ignore invalid URLs
      }
    });
  }
  initGoogleTranslate() {
    const translateElement = document.querySelector('.translate-list');
    
    if (translateElement) {
      document.querySelectorAll('.translate-list a').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = link.getAttribute('href');
          location.reload();
        });
      });
    }
  }
}